import React from 'react';
import { PaddingWrapper, HeaderBlock, Title, TextDescription, ContentBlock, MainHeader, MainContentUl, ItemLi, Column, FooterBlock } from './styled';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';

const SeoBlock = props => {
    return (
        <PaddingWrapper bgColor={props.bgColor} nonTopPadding={props.nonTopPadding} >
            <GridContainer>
                <HeaderBlock textColor={props.textColor}>
                    <Title>Установите Wi-Fi-камеру и следите за тем, что происходит в квартире</Title>
                    <TextDescription>Установите
                        видеонаблюдение и следите за тем, что происходит в квартире, даже если вы на даче, в отпуске или
                        командировке. Видеозаписи с ip-камеры будут приходить на смартфон. Вы сможете вовремя вызвать
                        полицию, если в дом проникнут воры. Будете в курсе, как обращается с ребенком няня и что дети
                        делают дома одни. Сможете контролировать бригаду ремонтников, чтобы они не пили полдня чай, а
                        клеили обои и сдавали все работы в срок.
                    </TextDescription>
                </HeaderBlock>
                <ContentBlock>
                        <MainHeader>Как работает видеокамера?</MainHeader>
                        <MainContentUl>
                            <Column>
                                <ItemLi>Подключите устройство к интернету через Wi-Fi-роутер и управляйте им через
                                    приложение на смартфоне.
                                </ItemLi>
                                <ItemLi>Камера реагирует на движение. Она сразу начнет снимать, если кто-то зайдет в
                                    квартиру, и отправит уведомление на ваш смартфон.
                                </ItemLi>
                                <ItemLi>Вы услышите все: звуки тоже записываются.</ItemLi>
                            </Column>
                            <Column>
                                <ItemLi>Камера записывает видео в формате Full-HD — картинка будет четкой даже ночью и
                                    при плохом освещении.
                                </ItemLi>
                                <ItemLi>Видеозаписи загружаются в архив и хранятся там 14 дней. Забыли, куда положили
                                    бумажник или ключи — посмотрите видео в архиве.
                                </ItemLi>
                            </Column>
                        </MainContentUl>
                </ContentBlock>
                <FooterBlock>
                    <p>Чтобы купить систему видеонаблюдения с записью видео по выгодной цене в {props.currentCity.cityIn},
                        оставьте на сайте заявку на подключение. С вами свяжется
                        специалист, чтобы уточнить удобную дату и время доставки.</p>
                </FooterBlock>
            </GridContainer>
        </PaddingWrapper>
    );
};

export default SeoBlock;
